class ProductGridSwitcher extends HTMLElement {
  constructor() {
    super();
    this.onButtonClick = this.onButtonClick.bind(this);

    this.desktopClasses = [
      'grid--3-col-desktop',
      'grid--4-col-desktop',
      'grid--6-col-desktop'
    ];

    this.tabletDownClasses = [
      'grid--2-col-tablet-down',
      'grid--3-col-tablet-down'
    ];
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('button');
    if (!this.buttons.length) return;

    this.restoreLayout();

    this.buttons.forEach(btn =>
      btn.addEventListener('click', this.onButtonClick)
    );

    document.addEventListener('product-grid:updated', () => {
      this.applyLayout();
    });
  }

  disconnectedCallback() {
    this.buttons.forEach(btn =>
      btn.removeEventListener('click', this.onButtonClick)
    );
  }

  onButtonClick(event) {
    const btn = event.currentTarget;
    const cols = btn.dataset.cols;
    const isMobile = btn.classList.contains('large-up-hide');

    if (isMobile) {
      localStorage.setItem('gridTabletDown', cols);
    } else {
      localStorage.setItem('gridDesktop', cols);
    }

    this.applyLayout();
    this.updateButtons(btn,isMobile);
  }

  restoreLayout() {
    this.applyLayout();

    const savedDesktop = localStorage.getItem('gridDesktop');
    const savedTablet = localStorage.getItem('gridTabletDown');

    if (savedDesktop) {
      const btn = this.querySelector(`button[data-cols="${savedDesktop}"]:not(.large-up-hide)`);
      if (btn) this.updateButtons(btn,false);
    }

    if (savedTablet) {
      const btn = this.querySelector(`button[data-cols="${savedTablet}"].large-up-hide`);
      if (btn) this.updateButtons(btn,true);
    }
  }

  applyLayout() {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const desktopCols = localStorage.getItem('gridDesktop') || '4';
    const tabletCols = localStorage.getItem('gridTabletDown') || '2';

    grid.classList.remove(...this.desktopClasses);
    grid.classList.remove(...this.tabletDownClasses);
  
    grid.classList.add(`grid--${desktopCols}-col-desktop`);
    grid.classList.add(`grid--${tabletCols}-col-tablet-down`);
  }

  updateButtons(activeBtn, isMobile) {
    this.buttons.forEach(btn => {
      const isActive = btn === activeBtn;
      if (isMobile && btn.classList.contains('large-up-hide')) {
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      } else if (isMobile == false && btn.classList.contains('small-hide')) {
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
    });
  }
}

customElements.define('product-grid-switcher', ProductGridSwitcher);

class QuickATC extends HTMLElement {
  constructor() {
    super();
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onVariantClick = this.onVariantClick.bind(this);
  }

  connectedCallback() {
    console.log('this ---> ', this)
    this.wrapper = this.closest('.product-card-wrapper');
    if (!this.wrapper) return;

    this.button = this.wrapper.querySelector('quick-atc-btn');
    this.formWrapper = this.wrapper.querySelector('quick-atc-form');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (!this.button || !this.formWrapper) return;

    this.button.addEventListener('click', this.onButtonClick);
    this.formWrapper.addEventListener('click', (evt) => this.onClose(evt.target));

    // this.wrapper.querySelectorAll('.qatc-form-variant-input')
    //   .forEach(el => el.addEventListener('click', this.onVariantClick));

    this.wrapper.querySelectorAll('.qatc-form-variant-input input')
  .forEach(input => input.addEventListener('change', this.onVariantClick));

   // this.imagesList();

    // this.wrapper.addEventListener('mouseenter', () => {
    //   if (this.wrapper.querySelector('.slideshow__autoplay')) {
    //     this.wrapper.querySelector('.slideshow__autoplay').setAttribute('aria-label', 'Play slideshow');
    //   }
    // });

    // this.wrapper.addEventListener('mouseleave', () => {
    //   if (this.wrapper.classList.contains('active')) {
    //     this.wrapper.classList.remove('active');
    //   }

      // if (this.wrapper.querySelector('.slideshow__autoplay')) {
      //   this.wrapper.querySelector('.slideshow__autoplay').setAttribute('aria-label', 'Pause slideshow');
      // }
  //  });

  // Mobile - click outside
  // document.addEventListener('touchstart', (e) => {
  //   if (
  //     this.wrapper.classList.contains('active') &&
  //     !this.wrapper.contains(e.target)
  //   ) {
  //     this.wrapper.classList.remove('active');

  //   }
  // });

  }

  disconnectedCallback() {
   // this.button?.removeEventListener('click', this.onButtonClick);

    this.wrapper?.querySelectorAll('.qatc-form-variant-input')
      .forEach(el => el.removeEventListener('click', this.onVariantClick));
  }

  onButtonClick() {
    this.wrapper.classList.add('active');
    document.body.classList.add('overflow-hidden')
  }

  onClose(evt) {
    if (evt.tagName === this.tagName) {
      this.wrapper.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }

  // imagesList() {
  //   const image_list = this.wrapper.querySelector('.image__container');
  //   const imageSources = image_list.dataset.images.split(',');

  //   if (!image_list || !imageSources) return;

  //   imageSources.forEach( src => {
  //     const img = document.createElement('img');
  //     img.src = src;
  //     img.alt = image_list.dataset.title || 'Insgnia Product';
  //     image_list.appendChild(img);
  //   });
  // }


  // async onVariantClick(event) {
  //   const input = event.currentTarget.querySelector('input[type="radio"]');
  //   if (!input || input.disabled) return;

  //   input.checked = true;

  //   const form = this.formWrapper.querySelector('form');
  //   const formData = new FormData(form);

  //   const config = fetchConfig('javascript');
  //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
  //   delete config.headers['Content-Type'];

  //   if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
  //     formData.append(
  //       'sections',
  //       this.cart.getSectionsToRender().map(section => section.id)
  //     );
  //     formData.append('sections_url', window.location.pathname);
  //     this.cart.setActiveElement(document.activeElement);
  //   }

  //   config.body = formData;

  //   try {
  //     const response = await fetch(routes.cart_add_url, config);
  //     const item = await response.json();
  //     console.log('resppo', response)

  //     if (!response.ok) return;

  //     if (this.cart && typeof this.cart.renderContents === 'function') {
  //       this.cart.renderContents(item);
  //     }
  //     form.reset();
  //     this.wrapper.classList.remove('active');
  //     document.body.classList.remove('overflow-hidden');
  //   } catch (error) {
  //     console.error('Add to cart failed', error);
  //   }
  // }

  async onVariantClick(event) {
  const input = event.target;
  if (!input || input.disabled) return;

  const form = this.formWrapper.querySelector('form');
  const formData = new FormData(form);

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map(section => section.id).join(',')
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  try {
    const response = await fetch(routes.cart_add_url, config);

    if (!response.ok) return;

    const item = await response.json();

    if (this.cart && typeof this.cart.renderContents === 'function') {
      this.cart.renderContents(item);
    }

    form.reset();
    this.wrapper.classList.remove('active');
    document.body.classList.remove('overflow-hidden');

  } catch (error) {
    console.error('Add to cart failed', error);
  }
}
}

customElements.define('quick-atc-form', QuickATC);

class AjaxinateInfiniteScroll extends HTMLElement {
  connectedCallback() {
    const pagePerLoad = this.dataset.pagePerload || 16;

    const containerSelector = this.dataset.container || '#product-grid';
    const paginationSelector = this.dataset.pagination || '#AjaxinatePagination'
    this.countContainer = document.querySelector(
      this.dataset.countProductText || '#ProductCount'
    );


    this.container = document.querySelector(containerSelector);
    this.pagination = document.querySelector(paginationSelector);

    if (!this.container || !this.pagination || typeof Ajaxinate === 'undefined') return;

    new Ajaxinate({
      container: containerSelector,
      pagination: paginationSelector,
      method: this.dataset.method || 'scroll',
      loadingText: this.dataset.loadingText || 'LOADING',
      callback: () => {
        this.countText();
        document.dispatchEvent(new CustomEvent('product-grid:updated'));
      }
    });
  }

  countText() {
    const selector = this.dataset.countProductText || '#ProductCount';
    const countProductText = document.querySelector(selector);

    if (!countProductText) return;

    const totalItems = parseInt(countProductText.dataset.total) || 0;
    const loadedItems = this.container.children.length;

    countProductText.innerText = `Showing 1 - ${loadedItems} of ${totalItems} item(s)`;
  }

}

customElements.define('ajaxinate-infinite-scroll', AjaxinateInfiniteScroll);

class ColorSwatch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', () => this.render(this.closest('.product-card-wrapper'),this.dataset.productUrl,this.dataset.activeCard));
  }

  async render(wrapper,url,active) {
    if (!wrapper || !url) return;

    try {
      const response = await fetch(`${url}?view=card-product`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const html = await response.text();

      console.log('html',html)
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const card = doc.querySelector('.product-card-wrapper');
      
      if (active) card.classList.add('active');

      console.log('card', card);
      wrapper.replaceWith(card);
      
    } catch (error) {
      console.error('Error fetching product card:', error);
    }
  }
}

customElements.define('color-swatch', ColorSwatch);

